import { render } from "./MaintenanceDetails.vue?vue&type=template&id=0ae06bad"
import script from "./MaintenanceDetails.vue?vue&type=script&lang=js"
export * from "./MaintenanceDetails.vue?vue&type=script&lang=js"

import "./MaintenanceDetails.vue?vue&type=style&index=0&id=0ae06bad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__